import type { PublicApiKey } from '#packages/apilib';
import type { createGTMServiceApi } from './api';

export const GTMServiceApiKey: PublicApiKey<typeof createGTMServiceApi> = {
  name: 'GTMServiceApi',
  public: true,
};
